import * as types from '../constants/actionTypes';

export function create(data) {
    return { type: types.ADD_ROLES, data };
}